import React, { useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import AdminDashboard from './admindashboard';

const MedicalCertificate = () => {
  const certificateRef = useRef();

  const fieldRefs = {
    patientName: useRef(),
    age: useRef(),
    phone: useRef(),
    address: useRef(),
    gender: useRef(),
    appointmentDate: useRef(),
    reason: useRef(),
    doctorName: useRef(),
    issuedDate: useRef(),
  };

  const [form, setForm] = useState({
    patientName: '',
    age: '',
    phone: '',
    address: '',
    gender: '',
    appointmentDate: '',
    reason: '',
    doctorName: '',
    issuedDate: '',
  });

  const handleDownload = async () => {
    const canvas = await html2canvas(certificateRef.current);
    const imgData = canvas.toDataURL('image/png');

    // Get metadata (field positions)
    const metadata = Object.entries(fieldRefs).map(([key, ref]) => {
      const rect = ref.current.getBoundingClientRect();
      const containerRect = certificateRef.current.getBoundingClientRect();
      return {
        id: key,
        x: rect.left - containerRect.left,
        y: rect.top - containerRect.top,
      };
    });

    console.log('Metadata:', metadata); // You can send this to backend or save it

    // Download image
    const link = document.createElement('a');
    link.href = imgData;
    link.download = 'medical_certificate.png';
    link.click();
  };

  const renderValue = (value, id) =>
    value ? (
      <strong ref={fieldRefs[id]}>{value}</strong>
    ) : (
      <span ref={fieldRefs[id]} className="underline">____________</span>
    );

  return (
    <div>
      <AdminDashboard />
      <div className="d-flex align-items-center justify-content-center mt-10">
        <div ref={certificateRef} style={styles.certificate}>
          <h1 style={styles.header}>Certificate</h1>
          <p>This is to certify that {renderValue(form.patientName, 'patientName')}, aged {renderValue(form.age, 'age')},</p>
          <p>Phone: {renderValue(form.phone, 'phone')}</p>
          <p>Address: {renderValue(form.address, 'address')}</p>
          <p>Gender: {renderValue(form.gender, 'gender')}</p>
          <p>had an appointment on {renderValue(form.appointmentDate, 'appointmentDate')} and was advised rest due to {renderValue(form.reason, 'reason')}.</p>
          <p>This certificate is issued upon request for official purpose.</p>
          <br />
          <p>Doctor's Name: {renderValue(form.doctorName, 'doctorName')}</p>
          <p>Date of Issue: {renderValue(form.issuedDate, 'issuedDate')}</p>
        </div>
      </div>

      {/* Input form (optional) */}
      <div style={styles.form}>
        {/* {Object.keys(form).map((key) => (
          <input
            key={key}
            type={key.includes('Date') ? 'date' : 'text'}
            placeholder={key.replace(/([A-Z])/g, ' $1')}
            value={form[key]}
            onChange={(e) => setForm({ ...form, [key]: e.target.value })}
          />
        ))} */}
        <button className="btn btn-primary mt-3" onClick={handleDownload}>
          Download Certificate
        </button>
      </div>
    </div>
  );
};

const styles = {
  certificate: {
    width: '700px',
    margin: '30px auto',
    padding: '30px',
    border: '2px solid black',
    backgroundColor: '#fff',
    fontFamily: 'serif',
    lineHeight: '1.8',
    textAlign: 'left',
    position: 'relative',
  },
  header: {
    textAlign: 'center',
    textDecoration: 'underline',
    marginBottom: '20px',
  },
  form: {
    width: '700px',
    margin: '20px auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
};

export default MedicalCertificate;
